import React from 'react';

// Shh icon using the daughter's custom artwork
export const ShhIcon = ({ className = "w-6 h-6", ...props }) => (
  <img
    src="/shh-logo-new.jpeg"
    alt="Secrets Club"
    className={className}
    style={{ objectFit: 'contain' }}
    {...props}
  />
);

export default ShhIcon;
